export const UNITS_SEARCH_KEYS = [
    'assignedEventPrimarySubdivision',
    'callSign',
    'cfsCode',
    'cfsDescription',
    'dispatchArea',
    'displayLineFirst',
    'displayLineLast',
    'displayLineOptionalMiddle',
    'displayLineSubPremise',
    'equipment',
    'personnel',
    'placeName',
    'primarySubdivision',
    'primaryUnitType',
    'priority',
    'shiftNotes',
    'skills',
    'station',
    'subdivisions',
    'tag',
    'transportPlaceName',
    'unitClass',
    'unitStateDisplay',
    'unitUserCadIds',
];

export const EVENTS_SEARCH_KEYS = [
    'agencyEventNumber',
    'agencyName',
    'cfsCode',
    'cfsDescription',
    'dispatchArea',
    'displayLineFirst',
    'displayLineLast',
    'displayLineOptionalMiddle',
    'eventLocationNotes',
    'narrative',
    'placeName',
    'priority',
    'subdivisions',
];
